import 'react-table/react-table.css';
import './Users.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import ReactTable from 'react-table';
import moment from 'moment';
import clone from 'clone';

import { getUsers, saveUserStatus, setUsers } from "./store/actions";

import A from 'components/A';
import H2 from 'components/H2';
import LoadingCircle from 'components/LoadingCircle';
import PageContent from 'components/PageContent';
import ToggleSwitch from 'components/ToggleSwitch';

class Users extends React.Component {
    componentWillMount() {
        document.body.classList.add('users-page');
        this.props.getUsers();
    }

    componentWillUnmount() {
        document.body.classList.remove('users-page');
    }

    handleLockAccount = (user) => {
        user.status = user.status === 'L' ? 'A' : 'L';

        if(user.isFreelancer !== true && user.company != null) {
            user.company.status = user.status;
        }

        let users = clone(this.props.users.users);
        for(var i = 0; i < users.length; i++) {
            if(users[i].id === user.id) {
                users[i] = user;
                break;
            }
        }
        this.props.setUsers(users);
        this.props.saveUserStatus(user, user.status === 'L' ? 'lock' : 'unlock');
    };

    handleMakeAdmin = (user) => {
        user.isAdmin = !user.isAdmin

        let users = clone(this.props.users.users);
        for(var i = 0; i < users.length; i++) {
            if(users[i].id === user.id) {
                users[i] = user;
                break;
            }
        }
        this.props.setUsers(users);
        this.props.saveUserStatus(user, user.isAdmin === true ? 'add_admin' : 'remove_admin');
    };

    render() {
        const tierText = {
            monthly: '30 Day',
            semiannual: '6 Month',
            annual: 'Annual'
        };

        const columns = [
            {
                Header: 'First Name',
                accessor: 'firstName'
            }, {
                Header: 'Last Name',
                accessor: 'lastName'
            }, {
                Header: 'Email Address',
                accessor: 'email',
                minWidth: 200,
                Cell: props => <A href={`mailto:${props.original.email}`}>{props.original.email}</A>
            }, {
                Header: 'Account Type',
                id: 'accountType',
                accessor: (d) => d.isFreelancer ? 'Freelancer' : 'Business'
            }, {
                Header: 'Subscription Type',
                id: 'subscription',
                className: 'users__subscription-type',
                accessor: (d) => {
                    return d.isFreelancer === false ? tierText[d.company.subscriptionType] : ''
                }
            }, {
                Header: 'Subscription Status',
                id: 'subscription',
                className: 'users__subscription-active',
                accessor: (d) => {
                    return d.isFreelancer === false ? tierText[d.company.subscriptionStatus] : ''
                }
            }, {
                Header: 'Start Date',
                id: 'startDate',
                accessor: 'company.created_at',
                Cell: props => props.original.isFreelancer === false ? moment(props.original.company.created_at).format('MM-DD-YYYY') : ''
            }, {
                Header: 'Locked?',
                id: 'locked',
                sortable: false,
                width: 70,
                className: 'users__locked',
                Cell: props => props.original.isFreelancer ? (
                    <ToggleSwitch
                        checked={props.original.status === 'L'}
                        disabled={props.original.id === this.props.auth.user.id || props.original.isAdmin === true}
                        label="Locked"
                        name="locked"
                        onChange={() => this.handleLockAccount(clone(props.original))}
                    />
                ) : null
            }, {
                Header: 'Admin?',
                id: 'admin',
                sortable: false,
                width: 70,
                className: 'users__locked',
                Cell: props => (
                    <ToggleSwitch
                        checked={props.original.isAdmin === true}
                        disabled={props.original.id === this.props.auth.user.id}
                        label="Admin"
                        name="isAdmin"
                        onChange={() => this.handleMakeAdmin(clone(props.original))}
                    />
                )
            }
        ];

        return (
            <PageContent className="users">
                {this.props.users.isFetching ? (
                    <LoadingCircle />
                ) : (
                    <React.Fragment>
                        <H2>
                            Admin User Management
                        </H2>
                        <ReactTable
                            columns={columns}
                            data={this.props.users.users}
                            loading={false}
                            loadingText=""
                            pageSize={this.props.users.users.length}
                            showPagination={false}
                            defaultSorted={[
                                {
                                    id: "lastName",
                                    desc: false
                                }
                            ]}
                        />
                    </React.Fragment>
                )}
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        users: state.users
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        getUsers: () => dispatch(getUsers()),
        saveUserStatus: (userObj, command) => dispatch(saveUserStatus(userObj, command)),
        setUsers: (usersArray) => dispatch(setUsers(usersArray))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);



// WEBPACK FOOTER //
// ./src/containers/Users/index.js